<template>
<div class="wrapper">
    <iframe src="https://vimeo.com/showcase/6134325/embed" allowfullscreen frameborder="0" class="frame"></iframe>
</div>
</template>

<script>
export default {
    name: "help-videos-page"
}
</script>

<style scoped>
.wrapper {
    margin: 0 auto;
    padding: 51.74% 0 0 0;
    position: relative;
    width: 96%;
}

.frame {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/HelpVideosPage.vue